<div class="tw-relative tw-flex tw-flex-col tw-gap-3 tw-bg-gray-75 tw-rounded-3 tw-shadow-z13 tw-p-4 tw-overflow-hidden">
  @if (collapsed()) {
    <!-- collapsed: title + nutritionist subtitle, broccoli peeking from the bottom-right corner -->
    <div class="tw-flex tw-flex-col tw-pr-[80px]">
      <p class="tw-font-lexend tw-font-bold tw-text-400 tw-text-black" i18n="@@dietLifestyleGuidance">Diet &amp; Lifestyle Guidance</p>
      <div class="tw-flex tw-items-center tw-gap-1">
        <p class="tw-font-body tw-italic tw-text-200 tw-text-gray-500 tw-opacity-80" i18n="@@givenByYourNutritionist">given by your nutritionist</p>
        <img class="tw-h-3 tw-w-3 tw-flex-shrink-0" src="/assets/icons/chevron_right_teal.svg" alt="" />
      </div>
    </div>
    <img class="tw-absolute tw-right-1 -tw-bottom-3 tw-h-20 tw-w-20 tw-rotate-[-28deg]" src="/assets/images/diet-broccoli.png" alt="" />
  } @else {
    <!-- expanded header -->
    <div class="tw-flex tw-items-center tw-gap-3">
      @if (isInstructionPage()) {
        <img class="tw-h-10 tw-w-10 tw-rounded-full tw-object-cover tw-flex-shrink-0" src="/assets/images/diet-doctor.png" alt="doctor" />
      }
      <div class="tw-flex tw-flex-col tw-flex-1">
        <p class="tw-font-lexend tw-font-bold tw-text-500 tw-leading-tight tw-text-black" i18n="@@dietLifestyleGuidance">Diet &amp; Lifestyle Guidance</p>
        <div class="tw-flex tw-items-center tw-gap-0.5">
          @if (isInstructionPage()) {
            @if (isHair()) {
              <p class="tw-font-body tw-italic tw-text-200 tw-text-gray-500 tw-opacity-80" i18n="@@toImproveYourHairHealth">to improve your hair health</p>
            } @else {
              <p class="tw-font-body tw-italic tw-text-200 tw-text-gray-500 tw-opacity-80" i18n="@@toImproveYourSkinHealth">to improve your skin health</p>
            }
          } @else {
            <p class="tw-font-body tw-italic tw-text-200 tw-text-gray-500 tw-opacity-80" i18n="@@givenByYourNutritionist">given by your nutritionist</p>
          }
          @if (!isUnpaidUser()) {
            <img class="tw-h-3 tw-w-3 tw-flex-shrink-0" src="/assets/icons/chevron_right_teal.svg" alt="" />
          }
        </div>
      </div>
      @if (isHomePage()) {
        <img class="tw-h-8 tw-w-8 tw-flex-shrink-0" src="/assets/gifs/diet-salad.gif" alt="" />
      }
    </div>
    <div class="tw-h-px tw-w-full tw-bg-black tw-opacity-10"></div>
    @if (!isHair()) {
      <!-- FACE: Avoid then Follow -->
      <div class="tw-flex tw-flex-col tw-gap-0.5">
        <p class="tw-font-body tw-italic tw-text-200 tw-text-gray-500 tw-opacity-80" i18n="@@dietAvoidLabel">Avoid</p>
        <div class="tw-flex tw-flex-col tw-gap-2 tw-justify-center tw-border tw-border-solid tw-border-gray-200 tw-rounded-2 tw-p-3 tw-pr-2 tw-bg-orange-30">
          @if (isAcneConcern()) {
            <p class="tw-font-lexend tw-text-300 tw-leading-tight tw-text-gray-800">🥛 <span i18n="@@milkAndOtherDairyProducts">Milk &amp; Other Dairy Products</span> ❌</p>
          }
          <p class="tw-font-lexend tw-text-300 tw-leading-tight tw-text-gray-800">🧁 <span i18n="@@dietSugar">Sugar</span> ❌</p>
          <p class="tw-font-lexend tw-text-300 tw-leading-tight tw-text-gray-800">🍟 <span i18n="@@friedAndJunkFood">Fried &amp; Junk Food</span> ❌</p>
          @if (!isAcneConcern()) {
            <p class="tw-font-lexend tw-text-300 tw-leading-tight tw-text-gray-800">🥃 <span i18n="@@alcoholAndSmoking">Alcohol &amp; Smoking</span> ❌</p>
          }
        </div>
      </div>
      <div class="tw-flex tw-flex-col tw-gap-0.5">
        <p class="tw-font-body tw-italic tw-text-200 tw-text-gray-500 tw-opacity-80" i18n="@@dietFollowLabel">Follow</p>
        <div class="tw-flex tw-flex-col tw-gap-2 tw-justify-center tw-border tw-border-solid tw-border-gray-200 tw-rounded-2 tw-p-3 tw-pr-2 tw-bg-green-30">
          <p class="tw-font-lexend tw-text-300 tw-leading-tight tw-text-gray-800"><span i18n="@@drinkEightGlassesWaterDaily">Drink 8 glass (2 litres) of water daily</span> ✅</p>
        </div>
      </div>
    } @else {
      <!-- HAIR: Follow then Avoid -->
      <div class="tw-flex tw-flex-col tw-gap-0.5">
        <p class="tw-font-body tw-italic tw-text-200 tw-text-gray-500 tw-opacity-80" i18n="@@dietFollowLabel">Follow</p>
        <div class="tw-flex tw-flex-col tw-gap-2 tw-justify-center tw-border tw-border-solid tw-border-gray-200 tw-rounded-2 tw-p-3 tw-pr-2 tw-bg-green-30">
          <p class="tw-font-lexend tw-text-300 tw-leading-tight tw-text-gray-800">🫘 <span i18n="@@proteinInEveryMeal">Protein in every meal</span> ✅</p>
          <p class="tw-font-lexend tw-text-300 tw-leading-tight tw-text-gray-800">🥬 <span i18n="@@ironVitaminOmega3RichFoods">Iron, Vitamin, Omega 3-rich foods</span> ✅</p>
          <p class="tw-font-lexend tw-text-300 tw-leading-tight tw-text-gray-800">🧘🏻‍♀️ <span i18n="@@manageStressMeditation">Manage Stress (meditation etc.)</span> ✅</p>
        </div>
      </div>
      <div class="tw-flex tw-flex-col tw-gap-0.5">
        <p class="tw-font-body tw-italic tw-text-200 tw-text-gray-500 tw-opacity-80" i18n="@@dietAvoidLabel">Avoid</p>
        <div class="tw-flex tw-flex-col tw-gap-2 tw-justify-center tw-border tw-border-solid tw-border-gray-200 tw-rounded-2 tw-p-3 tw-pr-2 tw-bg-orange-30">
          <p class="tw-font-lexend tw-text-300 tw-leading-tight tw-text-gray-800">💇🏻‍♀️ <span i18n="@@randomChemicalHairTreatments">Random chemical hair treatments</span> ❌</p>
          <p class="tw-font-lexend tw-text-300 tw-leading-tight tw-text-gray-800">🍯 <span i18n="@@dietSugar">Sugar</span> ❌</p>
          <p class="tw-font-lexend tw-text-300 tw-leading-tight tw-text-gray-800">🍟 <span i18n="@@friedAndJunkFood">Fried &amp; Junk Food</span> ❌</p>
        </div>
      </div>
    }
  }
</div>
